import { FiMinimize2, FiMaximize2 } from "react-icons/fi";
import "../css/MinimizeButton.css";

const MinimizeButton = ({
  minimized,
  onClick,
}: {
  minimized: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className="minimize-button"
    >
      {minimized ? (
        <FiMaximize2 size="1.5rem" />
      ) : (
        <FiMinimize2 size="1.5rem" />
      )}
    </div>
  );
};

export default MinimizeButton;
